/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { EmbeddedTelemetryViewer } from '@/components/EmbeddedTelemetryViewer/EmbeddedTelemetryViewer';

export function ChangeAuditPage() {
  return <EmbeddedTelemetryViewer path="/change-audit" iframeTitle="Change Audit" />;
}
